import React from 'react'

import ModalErrorMessage from './modalErrorMessage'
import ItemSummary from './itemSummary'
import LoadItemMatrixError from './loadItemMatrixError'
import ItemSupportUpgrade from './itemSupportUpgrade'
import { getCurrentSiteDomain } from '../../../../../common/utils/sites'
import OkIcon from '../../icons/ok'

export default ({
  item,
  itemMatrix,
  selectedMatrixLicense,
  selectedMatrixSupport,
  onMatrixLicenseChange,
  onMatrixSupportChange,
  loadItemMatrixError,
  modalMessages,
  closeModal,
  editCartEntry,
  goToEditScreen,
  cartEntry,
  updateMatrixSupport,
  hasSupportBeenExtended,
  currentSite
}) => {
  // the selected support could be one of none/bundle_6month/bundle_12month
  // and it could be show in the follwing two cases:
  // 1. user has selected a support, and the support is `bundle_6month`
  // 2. user has extended support
  const shouldShowExtendedSupport =
    (selectedMatrixSupport && selectedMatrixSupport === 'bundle_6month') ||
    hasSupportBeenExtended

  // Temporary link to cart page, will need to set to real checkout page later.
  const currentSiteDomain = getCurrentSiteDomain(currentSite)
  const checkoutPageLink = `//${currentSiteDomain}/cart`

  return (
    <div className="fds-c-modal -width-m modal">
      <header className="fds-c-modal__header fds-u-text-align-center fds-u-p3">
        <h1 className="fds-c-text-heading -size-s fds-u-mb0">
          <OkIcon width="40" height="40" />
        </h1>
        <h2 className="fds-c-text-heading -size-m fds-u-mb0">
          Item added to your cart
        </h2>
      </header>

      {loadItemMatrixError && <LoadItemMatrixError />}

      {modalMessages && <ModalErrorMessage modalMessages={modalMessages} />}

      <ItemSummary
        item={item}
        itemMatrix={itemMatrix}
        selectedMatrixLicense={selectedMatrixLicense}
        selectedMatrixSupport={selectedMatrixSupport}
        showChangeDetailsLink
        goToEditScreen={goToEditScreen}
        cartEntry={cartEntry}
      />

      {shouldShowExtendedSupport && (
        <ItemSupportUpgrade
          selectedMatrixLicense={selectedMatrixLicense}
          itemMatrix={itemMatrix}
          editCartEntry={editCartEntry}
          cartEntry={cartEntry}
          updateMatrixSupport={updateMatrixSupport}
        />
      )}

      {!loadItemMatrixError && (
        <footer className="fds-c-modal__footer">
          <div className="fds-c-modal__footer-cta -align-left">
            <button className="fds-c-button -color-light" onClick={closeModal}>
              Keep Browsing
            </button>
          </div>

          <div className="fds-c-modal__footer-cta -align-right">
            <a
              className="fds-c-button--3d -color-primary"
              href={checkoutPageLink}
            >
              Go to Checkout
            </a>
          </div>
        </footer>
      )}
    </div>
  )
}
